import styled from 'styled-components';
import { Layout } from 'antd';
import { Button as StyledButton } from '../../../styles/buttons'

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const TableContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
    }
`;

export const ResponsiveTable = styled.div`
`;

export const ResponsiveRow = styled.div`
  display: flex;
  margin: 0 12px 12px 0;
  justify-content: space-between;

  text-align: center;
  align-items: center;

  border-radius: 8px;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const ResponsiveColumn = styled.div`
  text-align: center;
  word-wrap: break-word;
  font-size: 12px;
  padding: 7px;
`;

export const Button = styled(StyledButton)`
  width: unset;
  margin-top: 0;
  align-self: flex-end;
  border-radius: 20px;
`;

export const ZeroWrapper = styled(Layout)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
`;

export const DiscountRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`
export const ModalContentWrapper = styled.div`
  background: #F5F5F5;
  padding: 1rem;
`;

export const Card = styled.div`
  background: white;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

export const CardTitle = styled.h2`
  margin-top: 0;
`;

export const CardParagraph = styled.p`
  margin: 0.5rem 0;
`;

export const CardList = styled.ul`
  margin: 0.5rem 0 1rem 1.5rem;
  padding: 0;
`;

export const CardListItem = styled.li`
  margin: 0.25rem 0;
`;

export const CardTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
`;

export const CardTableHead = styled.thead`
  background: #F0F0F0;
`;

export const CardTableHeaderCell = styled.th`
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: left;
`;

export const CardTableCell = styled.td`
  border: 1px solid #ccc;
  padding: 0.5rem;
`;
